import TextInput from "./basicComponents/text-input";
import * as Icons from "../assets/SVGs/index";
import { useEffect, useState } from "react";
import Button from "./basicComponents/button";
import Select from "./basicComponents/select";
import {
    addUsefulLink,
    editUsefulLink,
} from "../state-management/actions/useful-links-actions";
import { useDispatch, useSelector } from "react-redux";
import {
    setAlert,
    setAlertContext,
    setAlertSeverity,
} from "../state-management/actions/alerts-actions";

interface FormData {
    name: string;
    link: string;
}
interface Props {
    groupName: any;
    data: any;
    onDataUpdate: any;
    setServerUpdate: any;
    serverUpdate: any;
}
export default function UsefulLinksForm({
    groupName,
    data,
    onDataUpdate,
    setServerUpdate,
    serverUpdate,
}: Props) {
    const dispatch = useDispatch();
    const { rowStatus } = useSelector((state: any) => state.globalState);
    const [select, setSelect] = useState("");
    const [formData, setFormData] = useState<FormData>({
        name: "",
        link: "",
    });

    const usersOptions = groupName
        ? groupName.map((name: any) => ({
              label: name.group_name,
              value: name._id,
          }))
        : [];

    const isEditingAllowed =
        rowStatus?.status && formData.name !== "" && formData.link !== "";

    useEffect(() => {
        if (rowStatus.status) {
            if (data && data.length > 0) {
                const editingData = data.find(
                    (item: any) => item._id === rowStatus.id
                );
                if (editingData) {
                    setFormData({
                        name: editingData.name || "",
                        link: editingData.link || "",
                    });
                    setSelect(editingData.group_id || "");
                }
            }
        } else {
            setFormData({ name: "", link: "" });
            setSelect("");
        }
    }, [rowStatus.status, rowStatus.id]);

    useEffect(() => {
        setFormData({
            name: "",
            link: "",
        });
        setSelect("");
    }, [serverUpdate]);

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleAlert = (status: boolean) => {
        if (status) {
            dispatch(setAlert(true));
            dispatch(setAlertSeverity("success"));
            dispatch(setAlertContext(" عملیات با موفقیت تکمیل شد"));
        }
    };

    const handleSelect = (e: any) => {
        const { value } = e.target;
        setSelect(value);
    };

    const handleSubmit = async () => {
        try {
            const response = await addUsefulLink({
                group_id: select,
                ...formData,
            })(dispatch);

            if (response) {
                onDataUpdate([...data, { group_id: select, ...formData }]);
                setServerUpdate((prev: any) => !prev);
                handleAlert(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleEdit = async () => {
        try {
            const response = await editUsefulLink(rowStatus.id, {
                ...formData,
                group_id: select,
            })(dispatch);

            if (response) {
                const updatedData = data.map((item: any) =>
                    item._id === rowStatus.id
                        ? { ...item, group_id: select, ...formData }
                        : item
                );
                onDataUpdate(updatedData);
                setServerUpdate((prev: any) => !prev);
                handleAlert(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="w-full">
            <div className="flex flex-col gap-y-11 w-full ">
                <div className="flex md:flex-row gap-y-[55px] gap-x-4 flex-col justify-between w-full">
                    <Select
                        options={usersOptions}
                        value={select}
                        onChange={handleSelect}
                        className="w-full"
                    />
                    <TextInput
                        name="name"
                        placeholder="عنوان لینک"
                        label="عنوان لینک های مربوطه"
                        RightIcon={<Icons.TitleIcon className="w-5 h-5" />}
                        value={formData.name}
                        onChange={handleChange}
                    />
                    <TextInput
                        name="link"
                        placeholder=" لینک را تایپ کنید"
                        label=" لینک"
                        RightIcon={<Icons.TitleIcon className="w-5 h-5" />}
                        value={formData.link}
                        onChange={handleChange}
                    />
                    <Button
                        variant={!isEditingAllowed ? "success" : "edit"}
                        title={!isEditingAllowed ? "ثبت" : "ثبت ویرایش"}
                        onClick={!isEditingAllowed ? handleSubmit : handleEdit}
                        paddingx="20px"
                    />
                </div>
            </div>
        </div>
    );
}
